<template>
  <div class="OrderDetail">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">采购订单</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ orderData.OrderNumber }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <span class="title">订单信息</span>
      <el-form class="form_table" border :model="orderData" ref="ruleForm" :inline-message="true">
        <el-form-item label="甲方">广电计量检测集团股份有限公司</el-form-item>
        <el-form-item label="订单编号">{{ orderData.OrderNumber }}</el-form-item>
        <el-form-item label="乙方">{{ orderData.SupplierName }}</el-form-item>
        <el-form-item label="订单日期">{{ orderData.CreateDate }}</el-form-item>
        <el-form-item label="成本公司">{{ orderData.CompanyName }}</el-form-item>
        <el-form-item label="所属中心">{{ orderData.BelongCenterName }}</el-form-item>
        <el-form-item label="电子PO单" v-if="orderData.CurrentStep > 3">
          <el-link @click="fnReadPdf(orderData.FileId)" :underline="false" style="color: #0361b1; padding-right: 15px"> 预览</el-link>
          <el-link @click="fnDownload(orderData.FileId)" :underline="false" style="color: #0361b1"> 下载</el-link>
        </el-form-item>
        <el-form-item v-if="orderData.CurrentStep > 3"></el-form-item>
      </el-form>
      <span class="title">采购货物清单</span>
      <el-table :data="materialList" show-summary :summary-method="getSummaries" class="table_wrap1">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column label="物品代码" prop="MaterialCode"></el-table-column>
        <el-table-column label="物品名称" prop="MaterialName"></el-table-column>
        <el-table-column label="规格型号(供货)" prop="Specification"></el-table-column>
        <el-table-column label="单价（元）" prop="PerPrice"></el-table-column>
        <el-table-column label="采购数量" prop="ActualCount"></el-table-column>
        <el-table-column label="合计总价" prop="SumFee"></el-table-column>
        <el-table-column label="收货公司" prop="ReceivingCompany"></el-table-column>
        <el-table-column label="期望到货日期" prop="ExpectedArrivalTime"></el-table-column>
        <el-table-column prop="PurchaseReason" label="备注"></el-table-column>
      </el-table>

      <span class="title">发货记录</span>

      <el-table :data="invoiceList" class="table_wrap1">
        <el-table-column label="物流公司" prop="LogisticsCompany"></el-table-column>
        <el-table-column label="快递编号" prop="ExpressNumber"></el-table-column>
        <el-table-column label="发货日期" prop="InvoiceDate"></el-table-column>
        <el-table-column label="发货单扫描件">
          <template slot-scope="props">
            <el-button type="text" @click.stop="fnDownload(props.row.FileId)">发货单扫描件.pdf</el-button>
          </template>
        </el-table-column>
        <el-table-column label="联系人" prop="Contactor"></el-table-column>
        <el-table-column label="联系电话" prop="Mobile"></el-table-column>
        <el-table-column label="备注" prop="Remark"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderData: {},
      materialList: [],
      invoiceList: [],
      orderId: this.$route.query.orderId
    }
  },
  mounted() {
    this.Init()
  },
  methods: {
    Init() {
      let config = {
        params: {
          orderId: this.orderId
        }
      }
      this.getRequest('/Order/GetOrderData', config).then((res) => {
        if (res.data.errcode == 0) {
          this.orderData = res.data.order
          this.materialList = res.data.materialList
          this.invoiceList = res.data.invoiceList
          this.materialList = this.materialList.filter((item) => {
            return Number(item.ConfirmResults) < 3
          })
        } else {
          this.$message.error({
            type: 'error',
            message: res.data.errmsg,
            duration: 3000
          })
        }
      })
    },
    fnReadPdf(fileId) {
      let routerData = this.$router.resolve({
        path: 'ReadPDF',
        query: {
          pdfUrl: encodeURIComponent('/Common/GetFileStream?fileId=' + fileId),
          pdfUrl1: ''
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnDownload(fileId) {
      let token = window.localStorage.getItem('loginToken')
      var url = '/Common/DownloadFile?FileId=' + fileId + '&token=' + token + '&FileName='
      this.downloadfile(this.baseURL + url)
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          if (index === 6) {
            sums[index] += ''
          } else {
            sums[index] = ''
          }
        } else {
          sums[index] = ''
        }
      })

      return sums
    }
  }
}
</script>

<style scoped lang="scss">
.OrderDetail {
  //重写el-table样式
  .el_table {
    width: 98%;
    margin: 0 auto;
    border: none;
  }

  .el_table ::v-deep .el-table__header {
    th {
      background: #d8eafa;
      text-align: center;
      border-bottom: 2px solid #e4e4e4;
      color: #333;
    }
  }

  .el_table ::v-deep .el-table__body-wrapper {
    tr {
      background-color: #e6f6fb;
    }

    td {
      text-align: center;
      border-bottom: 1px solid #e4e4e4;
      border-right: none;
      background-color: #fff;
    }
  }

  .change_inform ::v-deep.icon_tips2 {
    vertical-align: middle !important;
  }

  .changeInform_btn_wrap {
    width: 366px;
    margin: 40px auto 0;

    .btn_1 {
      background: #f60;
      border: 1px solid #f60;
      color: #fff;
      border-radius: 8px;
    }

    .btn_1:nth-of-type(1) {
      margin-right: 30px;
    }
  }

  .title2_span {
    margin-left: auto;
    color: #0660a2;
    font-weight: bold;
    font-size: 13px;
  }

  .btn {
    margin-left: 50px;
    color: #fff;
    border: 1px solid #6a96bc;
    border-radius: 5px;
    padding: 2px 18px;
    font-size: 15px;
    background: #2db7f5;
  }

  .change_inform {
    padding-top: 15px;

    .title {
      height: 34px !important;
      line-height: 40px !important;
      border-bottom: 1px solid #95c7f0 !important;
      margin-bottom: 13px;
      // padding-top: 15px !important;
    }

    ::v-deep .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: #95c7f0;
    }

    ::v-deep .table_wrap1 {
      table {
        margin: 0;

        border: none td, tr, th {
          border-color: #95c7f0;
        }

        th {
          border-top: 1px solid #95c7f0;
          border-right: 1px solid #95c7f0;
          border-color: #95c7f0;
          background-color: #d8eafa;

          &:first-child {
            border-left: 1px solid #95c7f0;
          }
        }

        td {
          &:first-child {
            border-left: 1px solid #95c7f0;
          }
        }
      }

      .el-table__body-wrapper {
        border-bottom: 1px solid #95c7f0;
      }
    }
  }
}
</style>